var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstantMix({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 40.5V23h-5v-5h15v5h-5v17.5h-5Zm0-27.5V.5h5V13h-5Zm10 0V8h5V.5h5V8h5v5h-15Zm5 27.5V18h5v22.5h-5Zm15 0V33h-5v-5h15v5h-5v7.5h-5Zm0-17.5V.5h5V23h-5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantMix);
export default __webpack_public_path__ + "static/media/instant_mix.c5f96d12d47ac565bc84df519a56e9db.svg";
export { ForwardRef as ReactComponent };